// Metadata for domain objects

import _ from 'lodash'

import FolderOverview from 'scoreboard/components/folder-overview'
import metadataAliases from './metadata-aliases'

// organizations
import Organization from 'scoreboard/organizations/organization'

import OrganizationsNav from 'scoreboard/organizations/organizations-nav'

// files (#21214 change "documents" section to "files")
import File from 'scoreboard/components/files/file'

import DocumentsView from 'scoreboard/documents/documents-overview'
import DocumentsFolderOverview from 'scoreboard/documents/documents-folder-overview'
import DocumentsNav from 'scoreboard/documents/documents-nav'
import DocumentsRouter from 'scoreboard/documents/documents-router'

// initiatives
import Initiative from 'scoreboard/initiatives/initiative'

import InitiativesNav from 'scoreboard/initiatives/initiatives-nav'
import InitiativesOverview from 'scoreboard/initiatives/overview/initiatives-overview'
import InitiativesRouter from 'scoreboard/initiatives/initiatives-router'

// reports
import Report from 'scoreboard/reports/report'

import ReportsNav from 'scoreboard/reports/reports-nav'
import ReportsOverview from 'scoreboard/reports/reports-overview'
import ReportsFolderOverview from 'scoreboard/reports/reports-folder-overview'
import ReportsRouter from 'scoreboard/reports/reports-router'

// scorecards
import ScorecardNode from 'scoreboard/scorecards/scorecard-node'

import ScorecardsNav from 'scoreboard/scorecards/scorecards-nav'
import ScorecardsOverview from 'scoreboard/scorecards/overview/scorecards-overview'
import ScorecardsRouter from 'scoreboard/scorecards/scorecards-router'

// charts
import Chart from 'scoreboard/charts/model/chart'

import ChartsNav from 'scoreboard/charts/charts-nav'
import ChartsOverview from 'scoreboard/charts/charts-overview'

// import chartTabs from 'scoreboard/charts/display/charts-tabs-template'
import ChartsRouter from 'scoreboard/charts/charts-router'

// dashboards
import Dashboard from 'scoreboard/dashboards/dashboard'

import DashboardsNav from 'scoreboard/dashboards/dashboards-nav'
import DashboardsOverview from 'scoreboard/dashboards/display/dashboards-overview'
import DashboardsFolderOverview from 'scoreboard/dashboards/dashboards-folder-overview'
import DashboardsRouter from 'scoreboard/dashboards/dashboards-router'

// strategy maps
import StrategyMap from 'scoreboard/strategy-maps/strategy-map'

import StrategyMapsNav from 'scoreboard/strategy-maps/strategy-maps-nav'
import StrategyMapsOverview from 'scoreboard/strategy-maps/strategy-maps-overview'
import StrategyMapsRouter from 'scoreboard/strategy-maps/strategy-maps-router'

// briefings
import Briefing from 'scoreboard/briefings/briefing'

import BriefingsNav from 'scoreboard/briefings/briefings-nav'
import BriefingsOverview from 'scoreboard/briefings/briefings-overview'
import BriefingsFolderOverview from 'scoreboard/briefings/briefings-folder-overview'
import BriefingsRouter from 'scoreboard/briefings/briefings-router'

// bookmarks
import Bookmark from 'scoreboard/bookmarks/bookmark'

import BookmarksNav from 'scoreboard/bookmarks/bookmarks-nav'
import BookmarksOverview from 'scoreboard/bookmarks/bookmarks-overview'
import BookmarksRouter from 'scoreboard/bookmarks/bookmarks-router'

// datasets
import Dataset from 'scoreboard/datasets/model/dataset'

import DatasetsNav from 'scoreboard/datasets/datasets-nav'
import DatasetsOverview from 'scoreboard/datasets/overview/datasets-overview'
import DatasetsRouter from 'scoreboard/datasets/datasets-router'

// home
import HomeRouter from 'scoreboard/home/home-router'

// admin
import AdminRouter from 'scoreboard/admin/admin-router'

// export
import ExportsRouter from './export/exports-router'

// forms
import Form from 'scoreboard/forms/model/form'

import FormsNav from 'scoreboard/forms/forms-nav'
import FormsOverview from 'scoreboard/forms/overview/forms-overview'
import FormsFolderOverview from 'scoreboard/forms/overview/forms-folder-overview'
import FormsRouter from 'scoreboard/forms/forms-router'

var metadataObjects = {

	organizations: {
		model: Organization,
		navView: OrganizationsNav
	},

	scorecards: {
		model: ScorecardNode,
		navView: ScorecardsNav,
		overview: _.constant(ScorecardsOverview),
		loadOptions: ScorecardsOverview.loadOptions,
		router: new ScorecardsRouter()
	},

	strategyMaps: {
		model: StrategyMap,
		navView: StrategyMapsNav,
		overview: function(model) {
			return model && model.get('type') == 'folder' ? DashboardsFolderOverview : StrategyMapsOverview
		},
		router: new StrategyMapsRouter()
	},

	charts: {
		model: Chart,
		navView: ChartsNav,
		overview: function(model) {
			return model && model.get('type') == 'folder' ? FolderOverview : ChartsOverview
		},
		router: new ChartsRouter()
	},

	dashboards: {
		model: Dashboard,
		navView: DashboardsNav,
		overview: function(model) {
			return model && model.get('type') == 'folder' ? DashboardsFolderOverview : DashboardsOverview
		},
		router: new DashboardsRouter()
	},

	initiatives: {
		model: Initiative,
		navView: InitiativesNav,
		overview: _.constant(InitiativesOverview),
		loadOptions: InitiativesOverview.loadOptions,
		router: new InitiativesRouter()
	},

	briefings: {
		model: Briefing,
		navView: BriefingsNav,
		overview: function(model) {
			return model && model.get('type') == 'folder' ? BriefingsFolderOverview : BriefingsOverview
		},
		router: new BriefingsRouter()
	},

	files: {
		model: File,
		navView: DocumentsNav,
		overview: function(model) {
			return model && model.get('type') == 'folder' ? DocumentsFolderOverview : DocumentsView
		},
		loadOptions: DocumentsView.loadOptions,
		router: new DocumentsRouter()
	},

	reports: {
		model: Report,
		navView: ReportsNav,
		overview: function(model) {
			return model && model.get('type') == 'folder' ? ReportsFolderOverview : ReportsOverview
		},
		loadOptions: ReportsOverview.loadOptions,
		router: new ReportsRouter()
	},

	bookmarks: {
		model: Bookmark,
		navView: BookmarksNav,
		overview: function(model) {
			return model && model.get('type') == 'folder' ? FolderOverview : BookmarksOverview
		},
		router: new BookmarksRouter()
	},

	datasets: {
		model: Dataset,
		navView: DatasetsNav,
		overview: function(model) {
			return model && model.get('type') == 'folder' ? FolderOverview : DatasetsOverview
		},
		loadOptions: DatasetsOverview.loadOptions,
		router: new DatasetsRouter()
	},

	admin: {
		router: new AdminRouter()
	},

	home: {
		router: new HomeRouter()
	},

	exports: {
		router: new ExportsRouter()
	},

	forms: {
		model: Form,
		navView: FormsNav,
		overview: function(model) {
			return model && model.get('type') == 'folder' ? FormsFolderOverview : FormsOverview
		},
		router: new FormsRouter()
	}

}

metadataAliases(metadataObjects)

export default metadataObjects

metadataObjects.__filename__ = 'components/metadata-objects.js'
